<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconLink_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M3.8 6.4a1.4 1.4 0 0 0-1.4 1.4v1.4a1.4 1.4 0 0 0 1.4 1.4h2.8a.7.7 0 1 1 0 1.4H3.8A2.8 2.8 0 0 1 1 9.2V7.8A2.8 2.8 0 0 1 3.8 5h2.8a.7.7 0 1 1 0 1.4zm4.9-.7a.7.7 0 0 1 .7-.7h2.8A2.8 2.8 0 0 1 15 7.8v1.4a2.8 2.8 0 0 1-2.8 2.8H9.4a.7.7 0 1 1 0-1.4h2.8a1.4 1.4 0 0 0 1.4-1.4V7.8a1.4 1.4 0 0 0-1.4-1.4H9.4a.7.7 0 0 1-.7-.7M5.2 8.5a.7.7 0 0 1 .7-.7h4.2a.7.7 0 1 1 0 1.4H5.9a.7.7 0 0 1-.7-.7"
        clip-rule="evenodd"
    />
</svg>
